export default "__VITE_ASSET__BZTCrMOM__"